import * as React from "react";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import DetailGroup from "common/components/controls/DetailGroup";
import { formatDate } from "common/utils/FmtDate";
import { Hostovani } from "common/api/Evidence/Clenove/HostovaniDlouhodoba";

interface ZakladniUdajeProps {
    hostovani: Hostovani;
    je_to_clen: boolean;
}

class ZakladniUdaje extends React.PureComponent<ZakladniUdajeProps>{

    render() {
        const { hostovani, je_to_clen } = this.props;

        const items: DetailGridItem[] = [
            { label: 'Datum poř.', content: formatDate(hostovani.dat_porizeni) },
            { label: 'Individuelní člen', show: je_to_clen !== true, content: `${hostovani.clen_pr} ${hostovani.clen_jm}, IDT ${hostovani.clen_idt}` },
            { label: 'Hostování z', content: hostovani.dom_klub_id ? hostovani.dom_klub_naz : "divize" },
            { label: 'Hostování do', content: hostovani.host_klub_naz },
            { label: 'Od data', content: formatDate(hostovani.datum_od) },
            { label: 'Do data', content: formatDate(hostovani.datum_do) },
        ];

        return <DetailGroup title="Základní údaje">
            <DetailGrid items={items} labelXS={4} />
        </DetailGroup>
    }
}

export default ZakladniUdaje;
